import { useTranslation } from 'react-i18next'

import { ArrowsLeftRightIcon, ArrowUDownLeftIcon, ChatTextIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Card, FormatNumber, Text } from '@reveni-io/reveni-ui'

import NoResultsFound from '@/common/components/NoResultsFound/NoResultsFound'
import { statisticSizes } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'
import ProgressBar from '@/metrics/components/ProgressBar/ProgressBar'

import ReasonSummaryHeaderSkeleton from './ReasonSummaryHeaderSkeleton/ReasonSummaryHeaderSkeleton'
import { summaryTitles } from './constants'
import * as Styles from './styles'

const ReasonSummaryHeader = ({ summary, loading, error, showExchanges, isSubReason }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const getStats = () => {
    const returnsStat = {
      label: t('Devoluciones'),
      Icon: ArrowUDownLeftIcon,
      value: summary.refund_count,
    }
    const totalPercentage = isSubReason
      ? { percentage: summary.reason_percentage, percentageLabel: t('de este motivo') }
      : { percentage: summary.percentage, percentageLabel: t('del total de unidades devueltas') }

    if (!showExchanges) return [{ ...returnsStat, ...totalPercentage }]

    return [
      { label: t('Total'), Icon: ChatTextIcon, value: summary.count, ...totalPercentage },
      { ...returnsStat, percentage: summary.refund_percentage, percentageLabel: t('de este motivo') },
      {
        label: t('Cambios'),
        Icon: ArrowsLeftRightIcon,
        value: summary.exchange_count,
        percentage: summary.exchange_percentage,
        percentageLabel: t('de este motivo'),
      },
    ]
  }

  if (error) {
    return (
      <Card>
        <NoResultsFound />
      </Card>
    )
  }

  if (loading || !summary) return <ReasonSummaryHeaderSkeleton showExchanges={showExchanges} />

  return (
    <Card>
      <Styles.Container>
        <Styles.Summary>
          <Styles.TitleContainer>
            <Text type="titleL">
              {!!summary.position && `#${summary.position} `}
              {t(isSubReason ? summaryTitles.subReason : summaryTitles.reason, { reason: summary.display })}
            </Text>
            <Text type="bodyMRegular" color={theme.colors.text.subtle}>
              {summary.base_return_reason}
            </Text>
          </Styles.TitleContainer>
          <Styles.ProgressBarContainer>
            <ProgressBar progress={Number(summary.percentage)} />
          </Styles.ProgressBarContainer>
        </Styles.Summary>
        <Styles.Stats>
          {getStats().map(stat => (
            <Statistic
              key={stat.label}
              size={statisticSizes.small}
              isOutlined={false}
              Icon={stat.Icon}
              label={stat.label}
              value={<FormatNumber style="decimal">{stat.value}</FormatNumber>}
              caption={
                <>
                  <FormatNumber style="percent">{Number(stat.percentage)}</FormatNumber> {stat.percentageLabel}
                </>
              }
            />
          ))}
        </Styles.Stats>
      </Styles.Container>
    </Card>
  )
}

export default ReasonSummaryHeader
